import type { Components, Theme } from '@mui/material';

export const buildMuiPaperComponent = (): Components<Omit<Theme, 'components'>>['MuiPaper'] => ({
  styleOverrides: {
    root: {
      '&.MuiPopover-paper.MuiMenu-paper': {
        marginTop: '8px',
        padding: 0,
      },
      '&.MuiAutocomplete-paper': {
        marginTop: '12px',
        padding: 0,
        borderRadius: '10px',
      },
    },
    elevation: {
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      borderRadius: '4px',
    },
  },
});
